(function () {
  function formatLineItem(item, index) {
    var title = item.product_title;
    if (item.variant_title && item.variant_title !== 'Default Title') {
      title += ' - ' + item.variant_title;
    }
    if (item.quantity > 1) {
      title += ' × ' + item.quantity;
    }
    return (index + 1) + '. ' + title;
  }

  function buildMessage(cart) {
    var lines = cart.items.map(formatLineItem).join('\n');
    return 'Hello!\n\nPlease send me a price quote for the following items:\n\n' + lines + '\n\nThank you!';
  }

  function handleClick(evt) {
    var btn = evt.target.closest('.js-send-whatsapp-order');
    if (!btn) return;

    var dataEl = btn.parentElement && btn.parentElement.querySelector('[data-whatsapp-cart-data]');
    if (!dataEl) dataEl = document.querySelector('[data-whatsapp-cart-data]');
    if (!dataEl) return;

    var cart;
    try {
      cart = JSON.parse(dataEl.textContent);
    } catch (error) {
      console.log(error); // eslint-disable-line
      return;
    }

    if (!cart.items || !cart.items.length) return;

    var message = buildMessage(cart);
    var url = 'https://wa.me/' + btn.dataset.whatsappNumber + '?text=' + encodeURIComponent(message);

    window.open(url, '_blank', 'noopener');
  }

  document.addEventListener('click', handleClick);
})();
